import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.9419 6.94194C11.186 6.69786 11.186 6.30214 10.9419 6.05806C10.6979 5.81398 10.3021 5.81398 10.0581 6.05806L7 9.11612L5.94194 8.05806C5.69786 7.81398 5.30214 7.81398 5.05806 8.05806C4.81398 8.30214 4.81398 8.69786 5.05806 8.94194L6.55806 10.4419C6.80214 10.686 7.19786 10.686 7.44194 10.4419L10.9419 6.94194Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
